
<div :class="classes(n())">
  <StepItemLine
    v-if="!isFirstStep"
    :activated="isLineActivated"
    :dashed="true"
  />
  <StepItemIcon
    :activated="isIconActivated"
    :small="true"
  />
</div>
